import { QueryKey } from 'constants/reactQuery';

export const activityPointQueryKey = {
  activityPointSeasons: [QueryKey.ActivityPointSeason] as const,
  activityPoint: [QueryKey.ActivityPointSeason, QueryKey.ActivityPoint] as const,
  attendanceCheck: (yearMonth: string) => [QueryKey.ActivityPointSeason, QueryKey.AttendanceCheck, yearMonth] as const,
  attendanceCheckNoti: () => [QueryKey.ActivityPointSeason, QueryKey.AttendanceCheck, 'noti'] as const,
  attendanceCheckParticipate: (attendanceCheckMonthId: number) =>
    [QueryKey.ActivityPointSeason, QueryKey.AttendanceCheck, 'months', attendanceCheckMonthId] as const,
  attendanceCheckMonths: [QueryKey.ActivityPointSeason, QueryKey.AttendanceCheck, 'months'] as const,
  activityPointAllRank: () => [...activityPointQueryKey.activityPoint, QueryKey.ActivityPointRank, 'all'] as const,
  activityPointSeasonRank: (seasonId?: number) =>
    [...activityPointQueryKey.activityPoint, QueryKey.ActivityPointRank, seasonId] as const,
  activityPointMyRank: () => [...activityPointQueryKey.activityPoint, QueryKey.ActivityPointRank, 'my'] as const,
  activityPointRankExcluded: () =>
    [...activityPointQueryKey.activityPoint, QueryKey.ActivityPointRank, 'excluded'] as const,
  activitySummary: (yearMonthDay: string) =>
    [...activityPointQueryKey.activityPoint, QueryKey.AcitivitySummary, yearMonthDay] as const,
  activityPastSeasons: () => [...activityPointQueryKey.activityPointSeasons, QueryKey.ActivityPastSeasons] as const,
};
